/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const splitInventoryItemDataSchema = z.object({
	currentQuantity: z.number(),
	splits: z.array(z.object({ quantity: z.number(), valueCents: z.number(), description: z.string().nullable() })),
})

export type SplitInventoryItemDataSchema = z.infer<typeof splitInventoryItemDataSchema>
